import { useTranslations } from "@jugl-web/utils";

export const TableNoSearchResults = () => {
  const { t } = useTranslations();

  return (
    <div className="flex w-full items-center justify-center py-10 text-[#1A2023]">
      {t({
        id: "invoices-items-page.no-search-results",
        defaultMessage: "No Results 😔",
      })}
    </div>
  );
};
